import { createApp } from 'vue'
import { applyOemDocumentChrome } from './config/oem'
import { SYSTEM_MAINTENANCE_ENABLED } from './config/env'
import MaintenancePage from './views/SystemMaintenancePage.vue'
import './assets/styles/fonts.css'
import './assets/styles/main.css'
import './assets/styles/popup-list.css'
import './assets/styles/vue-bits-tailwind.css'
import '@/components/common/styles/canvasSelectTrigger.scss'
import '@/components/common/styles/canvasToolsPanel.scss'

applyOemDocumentChrome()

const bootstrap = async () => {
  if (SYSTEM_MAINTENANCE_ENABLED) {
    createApp(MaintenancePage).mount('#app')
    return
  }

  // 维护模式下不加载这些模块，避免路由守卫、登录态恢复和埋点初始化。
  const [
    { default: App },
    { default: router },
    { createPinia },
    { default: ElementPlus, ElTooltip },
    { default: zhCn },
    ElementPlusIconsVue,
    { isNavigationFailure, NavigationFailureType },
    { initReport }
  ] = await Promise.all([
    import('./App.vue'),
    import('./router'),
    import('pinia'),
    import('element-plus'),
    import('element-plus/dist/locale/zh-cn.mjs'),
    import('@element-plus/icons-vue'),
    import('vue-router'),
    import('./utils/report')
  ])

  await import('element-plus/dist/index.css')
  await import('element-plus/theme-chalk/dark/css-vars.css')

  const app = createApp(App)

  ElTooltip.props.popperClass.default = 'app-tooltip'
  ElTooltip.props.offset.default = 4
  ElTooltip.props.hideAfter.default = 80
  ElTooltip.props.showArrow.default = false

  // 注册Element Plus图标
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

  app.use(createPinia())
  app.use(router)
  app.use(ElementPlus, { locale: zhCn })

  initReport()

  // 等首屏路由导航完成后再挂载，避免 Transition + 异步守卫导致编辑页重复挂载、重复拉 lite
  try {
    await router.isReady()
  } catch (error) {
    // 首屏静默 SSO 会中止当前路由并跳转换票，无需挂载即将离开的页面。
    if (isNavigationFailure(error, NavigationFailureType.aborted)) return
    throw error
  }
  app.mount('#app')
}

void bootstrap()
